import axios from "axios";
import { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

import { useAuth } from "hooks/useAuth";

export default function ScheduleMeetingModal({
  show,
  handleClose,
  product,
  meetingInfo,
  refetch,
  isEdit,
}) {
  const [meeting, setMeeting] = useState({});
  const [eventId, setEventId] = useState();
  const [statusId, setStatusId] = useState();
  const [isInPerson, setIsInPerson] = useState(
    meetingInfo?.additional_comments ? false : true,
  );
  const { authToken, csrfToken, currentUser } = useAuth();

  useEffect(() => {
    if (show) {
      axios
        .get(
          `${process.env.REACT_APP_DJANGO_ENDPOINT}calendar/status/get_all_statuses/`,
          {
            withCredentials: true,
            headers: {
              Authorization: `Token ${authToken}`,
            },
          },
        )
        .then((response) => {
          let currStatus = response.data.filter((status) =>
            status.text.includes("2"),
          );
          setStatusId(currStatus[0].id);
          axios
            .get(
              `${process.env.REACT_APP_DJANGO_ENDPOINT}calendar/status/get_event_by_status_and_product/?statusId=${currStatus[0]?.id}&productId=${product?.product_id}`,
              {
                withCredentials: true,
                headers: {
                  Authorization: `Token ${authToken}`,
                },
              },
            )
            .then((response) => {
              setEventId(response.data.id);
            })
            .catch((error) =>
              console.log("Unable to get Calendar Event: ", error),
            );
        })
        .catch((error) =>
          console.log("Unable to get Calendar Statuses: ", error),
        );
    }
  }, [show]);

  const handleChange = (e) => {
    setMeeting({ ...meeting, [e.target.name]: e.target.value });
  };

  const handleCreateCheckinMeeting = async () => {
    let data = {
      creator: currentUser.id,
      entrydate: new Date(
        new Date().setMinutes(
          new Date().getMinutes() - new Date().getTimezoneOffset(),
        ),
      ),
    };

    data = {
      ...data,
      pid: product.product_id,
    };

    if (meeting?.additional_comments) {
      data.additional_comments = meeting.additional_comments;
    }

    await axios
      .post(
        `${process.env.REACT_APP_DJANGO_ENDPOINT}top/checkin-meeting/`,
        data,
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": csrfToken,
            Authorization: `Token ${authToken}`,
          },
        },
      )
      .then(() => {
        setMeeting({});
        handleClose();
        refetch();
      })
      .catch((error) => console.log(error));
  };

  const handleUpdateCheckinMeeting = async (payload) => {
    let data = {};

    if (payload) {
      data = {
        ...data,
        ...payload,
        creator: meeting.creator.id,
        editor: currentUser.id,
        moddate: new Date(
          new Date().setMinutes(
            new Date().getMinutes() - new Date().getTimezoneOffset(),
          ),
        ),
      };
    } else {
      data = {
        ...data,
        pid: product.product_id,
        additional_comments: meeting.additional_comments,
        creator: meeting.creator.id,
        editor: currentUser.id,
        moddate: new Date(
          new Date().setMinutes(
            new Date().getMinutes() - new Date().getTimezoneOffset(),
          ),
        ),
      };
    }

    await axios
      .put(
        `${process.env.REACT_APP_DJANGO_ENDPOINT}top/checkin-meeting/${meeting.checkin_meeting_id}/`,
        data,
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": csrfToken,
            Authorization: `Token ${authToken}`,
          },
        },
      )
      .then(() => {
        refetch();
        setMeeting({});
        handleClose();
      })
      .catch((error) => console.log(error));
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    if (!form.checkValidity()) {
      e.stopPropagation();
    } else {
      isEdit ? handleUpdateCheckinMeeting() : handleCreateCheckinMeeting();
    }
  };

  useEffect(() => {
    if (show === false) {
      setMeeting({ ...meetingInfo });
    }
  }, [meetingInfo, show]);

  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => {
        handleClose();
      }}
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>
            Check-In Meeting Information for VID: {product.v_id}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mt-4">
            <Col>
              <Form.Check
                id="person"
                name="meeting_format"
                type="radio"
                label="Check-In Meeting In-Person/Video(Formal Meeting)"
                onChange={(e) => setIsInPerson(true)}
              />
            </Col>
            <Col>
              <Form.Check
                id="email"
                name="meeting_format"
                type="radio"
                label="Electronic Check-In(eCheck-In)"
                onChange={(e) => setIsInPerson(false)}
                defaultChecked
              />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <Form.Label>Additional Information</Form.Label>
              <Form.Control
                name="additional_comments"
                as="textarea"
                rows={3}
                onChange={handleChange}
                defaultValue={meeting?.additional_comments}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="light"
            type="button"
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
